var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoom = function SvgRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "room_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".room_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#8b9c8f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 23v-2c0-1.1.9-2 2-2s2 .9 2 2c0 .6.4 1 1 1h8c.6 0 1-.4 1-1 0-1.1.9-2 2-2s2 .9 2 2v2c0 .4-.1.8-.3 1.1-.6.9-1.7 1.8-1.7 2.9h-2v-2H15v2h-2c0-1.1-1.1-2-1.7-2.9-.2-.3-.3-.7-.3-1.1z",
    className: "room_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17h.6c1.3 0 2.4 1.1 2.4 2.4 0 .3.3.6.6.6h4.8c.3 0 .6-.3.6-.6 0-1.3 1.1-2.4 2.4-2.4h.6v-3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v3z",
    className: "room_svg__st1"
  })));
};
export default SvgRoom;